(function () {
var BYS = window.BYS = window.BYS || {};
BYS.splitWhy = function (html) {
if (!html) return { why: '', rest: '' };
var box = document.createElement('div');
box.innerHTML = html;
var marker = null;
var nodes = box.querySelectorAll('p, h1, h2, h3, h4, strong, b');
for (var i = 0; i < nodes.length; i++) {
if (/^\s*why\s+you/i.test(nodes[i].textContent || '')) { marker = nodes[i]; break; }
}
if (!marker) return { why: '', rest: box.innerHTML };
while (marker.parentNode && marker.parentNode !== box) marker = marker.parentNode;
var why = '', next = marker.nextElementSibling;
while (next && /^(UL|OL)$/.test(next.tagName)) {
why += next.outerHTML;
var kill = next; next = next.nextElementSibling; kill.parentNode.removeChild(kill);
}
marker.parentNode.removeChild(marker);
return { why: why, rest: box.innerHTML };
};
BYS.renderInfo = function (root, infoWrap, picked, garmEl, activeIdx, onToggle) {
if (!infoWrap) return;
var esc = BYS.esc;
var handles = [];
(picked || []).forEach(function (p) { handles.push(p.handle); });
function infoFor(handle) {
var src = root.querySelector('[data-bys-info="' + handle + '"]');
if (!src) return null;
var get = function (k) { var n = src.querySelector('[data-' + k + ']'); return n ? n.innerHTML.trim() : ''; };
var txt = function (k) { var n = src.querySelector('[data-' + k + ']'); return n ? (n.textContent || '').trim() : ''; };
var split = BYS.splitWhy(get('desc'));
var fabric = get('fabric');
if (!fabric) {
var bits = '';
if (txt('fabricname')) bits += '<p><strong>Fabric:</strong> ' + esc(txt('fabricname')) + '</p>';
if (txt('bestfor')) bits += '<p><strong>Best for:</strong> ' + esc(txt('bestfor')) + '</p>';
fabric = bits;
}
var draw = get('details');
var dbox = document.createElement('div');
dbox.innerHTML = draw;
if (dbox.children.length === 1 && dbox.firstElementChild.children.length > 0) {
draw = dbox.firstElementChild.innerHTML;
}
var dsplit = BYS.splitWhy(draw);
var care = get('care');
var origin = txt('origin');
var careorigin = '';
if (care) careorigin += care;
if (origin) careorigin += '<p><strong>Origin:</strong> ' + esc(origin) + '</p>';
return {
title: src.getAttribute('data-title') || '',
details: dsplit.rest || split.rest,
why: dsplit.why || split.why,
fabric: fabric,
careorigin: careorigin
};
}
var infos = [];
(picked || []).forEach(function (p) {
var inf = infoFor(p.handle);
if (inf) { inf.label = p.label || inf.title; infos.push(inf); }
});
if (!infos.length) {
infoWrap.hidden = true; infoWrap.innerHTML = '';
if (garmEl) garmEl.innerHTML = '';
var host = infoWrap.parentNode;
if (host && host.classList && host.classList.contains('bys__about')) host.hidden = true;
return;
}
var about = infoWrap.parentNode;
if (about && about.classList && about.classList.contains('bys__about')) about.hidden = false;
if (activeIdx == null || activeIdx >= infos.length || activeIdx < 0) activeIdx = 0;
var act = infos[activeIdx];
if (garmEl) {
var gf = document.activeElement && garmEl.contains(document.activeElement)
? document.activeElement.getAttribute('data-bys-garmbtn') : null;
if (infos.length > 1) {
var thtml = '';
infos.forEach(function (inf, k) {
thtml += '<button type="button" data-bys-garmbtn="' + k + '" aria-pressed="' +
(k === activeIdx) + '">' + esc(inf.label) + '</button>';
});
garmEl.innerHTML = thtml;
[].slice.call(garmEl.querySelectorAll('[data-bys-garmbtn]')).forEach(function (b) {
if (gf !== null && b.getAttribute('data-bys-garmbtn') === gf) b.focus();
b.addEventListener('click', function () {
BYS._infoSide = parseInt(b.getAttribute('data-bys-garmbtn'), 10) || 0;
BYS.renderInfo(root, infoWrap, picked, garmEl, BYS._infoSide, onToggle);
});
});
} else {
garmEl.innerHTML = '<button type="button" aria-pressed="true" disabled>' + esc(act.label) + '</button>';
}
}
function override(sel) {
var n = root.querySelector(sel);
return n ? n.innerHTML.trim() : '';
}
var shared = { fabric: override('[data-bys-tabfabric]'), careorigin: override('[data-bys-tabcare]') };
var TABS = [
{ key: 'details', label: 'Description' },
{ key: 'why', label: 'Why you will love it' },
{ key: 'fabric', label: 'Fabric and technology' },
{ key: 'careorigin', label: 'Care and origin' }
];
var html = '';
TABS.forEach(function (def, ti) {
var body = '';
if (shared[def.key]) {
body = '<div class="bys__acc-part">' + shared[def.key] + '</div>';
} else if (act[def.key]) {
body = '<div class="bys__acc-part">' + act[def.key] + '</div>';
}
if (!body) return;
var id = 'bysAcc' + ti;
var isOpen = !!(BYS._accOpen && BYS._accOpen[def.label]);
html += '<div class="bys__acc">' +
'<button class="bys__acc-btn" type="button" aria-expanded="' + isOpen + '" aria-controls="' + id + '" data-bys-acc="' + esc(def.label) + '">' +
esc(def.label) + '</button>' +
'<div class="bys__acc-panel" id="' + id + '"' + (isOpen ? '' : ' hidden') + '>' + body + '</div></div>';
});
infoWrap.innerHTML = html;
infoWrap.hidden = !html;
[].slice.call(infoWrap.querySelectorAll('.bys__acc-btn')).forEach(function (btn) {
btn.addEventListener('click', function () {
var open = btn.getAttribute('aria-expanded') === 'true';
btn.setAttribute('aria-expanded', String(!open));
var panel = document.getElementById(btn.getAttribute('aria-controls'));
if (panel) panel.hidden = open;
BYS._accOpen = BYS._accOpen || {};
BYS._accOpen[btn.getAttribute('data-bys-acc')] = !open;
});
});
};
})();
